module.exports = __webpack_public_path__ + "media/shen_me.ce05a435.mp3";